$('.top__menu-js .has-child').on('hover', ).hover(function () {
    if(isTouch || window.innerWidth <= 768)
        return;

    $('.top__menu-js .has-child').removeClass('active');
    $(this).addClass('active');
}, function () {
    if(isTouch || window.innerWidth <= 768)
        return;

    $(this).removeClass('active');
}).click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if(!isTouch && window.innerWidth > 768)
        return;

    if(!this.classList.contains('active'))
        $('.top__menu-js .has-child').removeClass('active');

    $(this).toggleClass('active');
});

$('.top__menu-js .has-child > .submenu').click(function (e) {
    e.stopPropagation();
});


$('#top-menu__hamburger-js').click(function () {
    $('.top__menu-list').slideToggle();
    $(this).toggleClass('active');
    $('#top-overlay-js').toggleClass('top-overlay--show');
});

$('#top-overlay-js').click(function () {
    $('.top__menu-list').slideUp();
    $(this).removeClass('top-overlay--show');
    $('#top-menu__hamburger-js').removeClass('active');
});


//fix position with admin bar
window.addEventListener('scroll', function () {
    if(pageYOffset > 0){
        $('#top-js').addClass('scrolled');
    }else{
        $('#top-js').removeClass('scrolled');
    }
});